exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".metaData li[data-v-061d0100]{font-family:SiemensSansGlobalCC-Roman,Helvetica Neue,Helvetica,sans-serif;font-size:.8125rem;color:#fff;line-height:1.38;text-align:center;color:#3c464b;display:block;overflow-wrap:break-word}", ""]);

// exports
